<template>
  <div  class="dialogBox">
    <div class="triangles"></div>
    <div class="top">
      <div>Start a new conversation</div>
      <div>
        <img src="../assets/diapatch/close@2x.png" alt="">
      </div>
    </div>
    <div class="line"></div>
    <div class="innerChat">
      <div
        v-for="(item,index) in allDriverList"
        :key="index"
        class="innerCon"
        @click="chooseChatDriver(item)">
        <div class="right_box">
          <div class="right_first_box" :class="item.is_online == 0?'':'green_line'">{{item.firstName}}</div>
          <div>{{item.name}}</div>
        </div>
        <div style="transform: translateY(25%);">
          <img src="../assets/diapatch/start_a_chat@2x.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getLeftAllDriverList, sendMeaasge, uploadFile} from "@/api/chatBox";
import {message} from "@/api/resetMessage";

export default {
  name: "driverBox",
  created() {
    this.getLeftAllDriverData()
  },
  data(){
    return{
      allDriverList:[],
    }
  },
  methods:{
    //获取所有司机
    getLeftAllDriverData(){
      getLeftAllDriverList().then(res=>{
        if (res.code == 200){
          this.allDriverList = res.data
          this.allDriverList.forEach(v=>{
            v.firstName = v.name.charAt(0).toUpperCase()+v.name.charAt(1).toUpperCase()
          })
        }
      })
    },
    //选择司机后，在右侧显示司机头像 并且关闭弹框
    chooseChatDriver(e){
      this.$emit('chooseAndClose',e)
    }
  }
}
</script>

<style scoped lang="less">
.dialogBox{
  position: relative;
  /deep/.el-dialog{
    border-radius: 0;
    background-color: RGBA(255, 255, 255, 0.5);
  }
  .triangles{
    position: absolute;
    top: -55px;
    left: 38px;
    width:0;
    height:0;
    border-width:0 15px 15px;
    border-style:solid;
    border-color:transparent transparent #FFFFFF;/*透明 透明  灰*/
    margin:40px auto;
  }
  .top{
    width: calc(100% - 32px);
    height: 30px;
    display: flex;
    justify-content: space-between;
    padding: 10px 16px 0;
    img {
      cursor: pointer;
      width: 16px;
    }
  }
  .line{
    width: 100%;
    height: 1px;
    background:#E0E0E0;
  }
  .noChat{
    text-align: center;
    padding-top: 50% !important;
  }
  .innerChat{
    width: 100%;
    height: 460px;
    box-sizing: border-box;
    overflow: auto;
    .innerCon{
      display: flex;
      justify-content: space-between;
      padding: 8px 16px;
      cursor: pointer;
      .right_box{
        display: flex;
        font-size: 14px;
        font-weight: 400;
        color: #1F2D42;
        line-height: 32px;
        .right_first_box{
          cursor: pointer;
          font-weight: 400;
          font-size: 14px;
          color: #1F2D42;
          width: 32px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          border-radius: 50%;
          background: #F5F6FB;
          border: 1px solid #e0e0e0;
          position: relative;
          margin-right: 12px;
        }
        .green_line{
          border: 1px solid #82D237;
        }
      }
      img{
        width: 16px;
        height: 16px;
      }
    } :hover{
        background-color: #E0E0E0;
          }

  }
}
</style>
